import { render, staticRenderFns } from "./StepBehalfOfChild.vue?vue&type=template&id=0c831cce&"
import script from "./StepBehalfOfChild.vue?vue&type=script&lang=js&"
export * from "./StepBehalfOfChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports